import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { getClassroomToDisplay } from './getClassroomsToDisplay';

export function getClassroomToDisplayAsString(
  classroomIds: string[],
  allClassrooms: Classroom[],
  classroomsOrg: ClassroomsOrg,
): string | undefined {
  const classroomsToDisplay = getClassroomToDisplay(
    classroomIds,
    allClassrooms,
    classroomsOrg,
  );
  return classroomsToDisplay?.length > 0
    ? classroomsToDisplay.map(c => c.name).join('-')
    : undefined;
}
